/*
 * @Author: your name
 * @Date: 2021-03-04 16:20:57
 * @LastEditTime: 2024-03-05 17:01:21
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\basics\mixins\index.js
 */
export const mPreview = {
  data() {
    return {
      previewData: {
        visible: false,
        type: "",
        src: ""
      }
    }
  },
  methods: {
    previewVisible() {
      this.$set(this.previewData, "visible", false);
    },
    handlePreview(index, row) {
      this.$set(this.previewData, "visible", true);
      this.$set(this.previewData, "type", row.type.toString());
      this.$set(this.previewData, "src", row.ref_url);
    }
  }
}

export const mPagination = {
  data() {
    return {
      current: 0,
      limit: 12,
      page: 1,
      groupId: this.$cookies.get("group_id"),
      groupIds: sessionStorage.getItem('group_ids'),
      keyword: undefined,
      dirId: 0,
    }
  }
}